// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ImageLoader_imageWrapper__QykjS","image":"ImageLoader_image__AZyUu","placeholder":"ImageLoader_placeholder__e53ei","pulse":"ImageLoader_pulse__qenm8"};